// ** Toolkit imports
import { AnyAction, combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

// ** Reducers
import auth from "./slice/auth";
import flight from "./slice/flight";
import update from "./slice/update";
import { authConfig } from "../utils/constants";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

const appReducer = combineReducers({
  auth,
  flight,
  update,
});

export type RootState = ReturnType<typeof appReducer>;

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["update"],
};

const rootReducer: any = (state: RootState, action: AnyAction) => {
  if (action.type === "auth/logout") {
    storage.removeItem("persist:root");
    localStorage.removeItem(authConfig.storageTokenKeyName);
    return appReducer(undefined, { type: "" });
  }

  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export const persistor = persistStore(store);
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();
